/*!
 * Ajaxinate
 * Copyright (c) 2017 Elkfox Co Pty Ltd (elkfox.com)
 * https://github.com/Elkfox/Ajaxinate
 * MIT License (do not remove)
 */

var Ajaxinate = function(config) {
  const settings = config || {};
  
  const defaults = {
    pagination: '.AjaxinatePagination',
    method: 'scroll',
    container: '.AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  
  // Merge configs
  this.settings = Object.assign(defaults, settings);
  
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleCall = this.stopMultipleCall.bind(this);
  this.removeClickListener = this.removeClickListener.bind(this);
  this.removeScrollListener = this.removeScrollListener.bind(this);
  
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  
  this.initialize();
};

Ajaxinate.prototype.initialize = function initialize() {
  if (!this.containerElement) {
    return console.error('Ajaxinate: container element not found');
  }
  
  if (!this.paginationElement) {
    return console.error('Ajaxinate: pagination element not found');
  }
  
  // Find the "next" link to determine if there are more pages
  const nextLink = this.paginationElement.querySelector('.pagination__item--prev');
  
  if (!nextLink) {
    // If there's no next link, we've reached the end of pagination
    const endElement = this.paginationElement.querySelector('.all-products-loaded');
    if (endElement && !endElement.classList.contains('is-visible')) {
      console.log('Showing end of results message');
      endElement.classList.add('is-visible');
    }
    return;
  }
  
  const initializers = {
    click: this.addClickListener,
    scroll: this.addScrollListeners
  };
  
  initializers[this.settings.method]();
};

Ajaxinate.prototype.addScrollListeners = function addScrollListeners() {
  if (!this.paginationElement) {
    return console.error('Ajaxinate: pagination element not found');
  }
  
  // Check if the next page link exists before adding event listeners
  const nextPageLink = this.paginationElement.querySelector('.pagination__item--prev');
  if (!nextPageLink) {
    console.log('Ajaxinate: No next page link found, not adding scroll listeners');
    
    // Show end of results message if available
    const endElement = this.paginationElement.querySelector('.all-products-loaded');
    if (endElement && !endElement.classList.contains('is-visible')) {
      endElement.classList.add('is-visible');
    }
    return;
  }
  
  // Log the next page URL that will be loaded
  console.log('Ajaxinate: Next page URL is', nextPageLink.href);
  
  document.addEventListener('scroll', this.checkIfPaginationInView);
  window.addEventListener('resize', this.checkIfPaginationInView);
  window.addEventListener('orientationchange', this.checkIfPaginationInView);
  this.checkIfPaginationInView();
};

Ajaxinate.prototype.addClickListener = function addClickListener() {
  if (!this.paginationElement) {
    return console.error('Ajaxinate: pagination element not found');
  }
  
  this.nextPageLinkElement = this.paginationElement.querySelector('a');
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.addEventListener('click', this.stopMultipleCall);
  }
};

Ajaxinate.prototype.stopMultipleCall = function stopMultipleCall(event) {
  event.preventDefault();
  if (!this.isLoading) {
    this.removeClickListener();
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPage(this.nextPageLinkElement.href);
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function checkIfPaginationInView() {
  const top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  const windowHeight = window.innerHeight;
  
  if (top <= windowHeight && !this.isLoading) {
    // Look specifically for the "next" link in the pagination
    // In Shopify, the next link is typically inside the pagination with a specific class
    this.nextPageLinkElement = this.paginationElement.querySelector('.pagination__item--prev');
    
    if (!this.nextPageLinkElement) {
      // Fall back to any link in the pagination
      this.nextPageLinkElement = this.paginationElement.querySelector('a');
    }
    
    this.removeScrollListener();
    
    if (!this.nextPageLinkElement) {
      // No more pages to load, show end message
      const endElement = this.paginationElement.querySelector('.all-products-loaded');
      if (endElement && !endElement.classList.contains('is-visible')) {
        endElement.classList.add('is-visible');
      }
      return;
    }
    
    console.log('Next link found:', this.nextPageLinkElement.href);
    this.isLoading = true;
    this.nextPage(this.nextPageLinkElement.href);
  }
};

Ajaxinate.prototype.nextPage = function nextPage(url) {
  this.isLoading = true;
  
  console.log('Loading next page from URL:', url);
  
  // Show loading indicator immediately
  const loadingElement = this.paginationElement.querySelector('.infinite-scroll-request');
  if (loadingElement) {
    loadingElement.style.display = 'block';
    loadingElement.classList.add('is-active');
  }
  
  fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.text();
    })
    .then(responseText => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(responseText, 'text/html');
      const newContainer = htmlDocument.querySelector(this.settings.container);
      const newPagination = htmlDocument.querySelector(this.settings.pagination);
      
      if (!newContainer) {
        console.error('Ajaxinate: No container element found in the response');
        return;
      }
      
      // Extract page number from URL for tracking
      let pageNumber = 1;
      try {
        const urlObj = new URL(url, window.location.origin);
        const pageParam = urlObj.searchParams.get('page');
        if (pageParam) {
          pageNumber = parseInt(pageParam, 10);
        }
      } catch (e) {
        console.warn('Ajaxinate: Could not parse URL', e);
      }
      
      console.log('Successfully loaded page:', pageNumber);
      
      // Process and add the new items
      const items = Array.from(newContainer.children);
      if (items.length > 0) {
        items.forEach(item => {
          item.setAttribute('data-ajaxinate-page', pageNumber);
          this.containerElement.appendChild(item);
        });
      } else {
        console.warn('Ajaxinate: No items found in the container');
      }
      
      // Update the pagination element with new links
      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      } else {
        console.warn('Ajaxinate: No pagination element found in the response');
        
        // If no pagination is found, we've likely reached the end
        const endElement = this.paginationElement.querySelector('.all-products-loaded');
        if (endElement && !endElement.classList.contains('is-visible')) {
          endElement.classList.add('is-visible');
        }
      }
      
      // Hide loading indicator
      if (loadingElement) {
        loadingElement.classList.remove('is-active');
        setTimeout(() => {
          loadingElement.style.display = 'none';
        }, 300);
      }
      
      if (this.settings.callback) {
        this.settings.callback(pageNumber);
      }
      
      this.initialize();
      this.isLoading = false;
    })
    .catch(error => {
      console.error('Ajaxinate error:', error);
      this.isLoading = false;
      
      // Hide loading indicator on error
      if (loadingElement) {
        loadingElement.classList.remove('is-active');
        loadingElement.style.display = 'none';
      }
    });
};

Ajaxinate.prototype.removeClickListener = function removeClickListener() {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleCall);
  }
};

Ajaxinate.prototype.removeScrollListener = function removeScrollListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};
